"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const HashLoader_1 = __importDefault(require("react-spinners/HashLoader"));
const LoadingPage = function (props) {
    return (react_1.default.createElement("div", { className: "_fill", style: { flexDirection: 'column' } },
        typeof props.message !== 'undefined' && react_1.default.createElement("h1", null, props.message),
        react_1.default.createElement(HashLoader_1.default, { size: 30, color: '#aaaaaa', loading: true })));
};
exports.default = LoadingPage;
//# sourceMappingURL=LoadingPage.js.map